// Node modules
import { IEvent } from "@quest/adapter-interface";
import { ingenuity, detectDeviceEnvironmentConstants as deviceEnvironment } from "@quest/base-core/dist";

import { gameConstants } from "../Constants/gameConstants";
import { BaseViewBehavior } from "@quest/murka-games-behavior-panther";

export class YouWonFeatureView extends BaseViewBehavior {
  // implement the you won feature view methods here.

  /**
   * Class method to show the view.
   */
  public showView(): void {
    this.visible = true;
  }

  /**
   * Class method to hide the view.
   */
  public hideView(): void {
    this.visible = false;
  }

  // Override to change view properties for mobile
  protected resize(evt: IEvent): void {
    super.resize(evt);
    if (ingenuity.deviceEnv.getOrientation() === deviceEnvironment.constants.ORIENTATION.PORTRAIT) {
      this.scale.set(ingenuity.deviceEnv.getPortraitMaxReelScale());
      this.y = this.y + gameConstants.BONUS_ALLIGN_WITH_BASE_GAME_ON_PORTRAIT;
    }
  }
}
